
import style from './header.component.module.scss';
import * as React from 'react';

interface HeaderState {
    openState: boolean;
    isSubheaderOpen: boolean;
    downloadableFileCount: number;
}

export default class HeaderComponent extends React.Component<{}, HeaderState> {

    constructor(props: any) {
        super(props);
        this.state = {
            openState: false,
            isSubheaderOpen: false,
            downloadableFileCount: 0,
        }
    }

    toggleMenu() {
        this.setState({
            openState: !this.state.openState,
        });
    }

    closeMenu() {
        if (this.state.openState) {
            this.setState({
                openState: false,
            });
        }
    }

    navigateToHome() {
        window.location.href = '/';
    }

    toggleSubheader() {
        this.setState({ isSubheaderOpen: !this.state.isSubheaderOpen });
    }

    subheaderToggled(state) {
        this.setState({ isSubheaderOpen: state });
    }

    render() {
        return (
            <header className="row">
                <div className={`${style.topnav} ${this.state.openState ? style.responsive : ''}`}>
                    <a href="/" className={style.title} onClick={() => this.navigateToHome()}>
                        XConvert
                    </a>
                    <a href="/unit-converter" onClick={e => this.closeMenu()}>Other Unit Converters</a>
                    {
                        <span className={style.links}>
                            <a href="/downloads" onClick={e => this.closeMenu()}>Downloads</a>
                            <a href="/compress-mp4" onClick={e => this.closeMenu()}>Compress MP4</a>
                        </span>
                    }
                </div>
            </header>
        );
    }
};
